<template>
  <div class="introduction-box">
    <transition name="introduction-demo">
      <div class="introduction-demo-area" v-show="isaActivated">
        <div class="introduction-title">ニュース・邦人NAVI</div>
        <ul>
          <li
            class="introduction-list"
            v-for="(n, index) in introductionList"
            :key="index"
            v-html="n"
          ></li>
        </ul>
        <div class="imag">
          <img :src="newsIcon" alt="" />
        </div>
      </div>
    </transition>
    <div class="introduction-image">
      <img :src="partsImage" v-show="isaActivated" />
    </div>
  </div>
</template>
<script>
import { newsIcon } from "../../../images/home/index";
export default {
  data() {
    return {
      introductionList: [
        "「ニュース・邦人NAVI」では、ニュースサイトや人気ブログ、",
        "微信公衆号を通して配信されるビジネスや生活、レジャーなど",
        "様々なジャンルのフレッシュな情報がキャッチできます。",
        "また最近では、「動画」コーナーも設置され、日本で話題の",
        "ニュースやドラマなどをご覧いただけるようになっています。"
      ],
      shadow: "box-shadow:0px 0px 108px 0px rgba(238,178,94,0.18);",
      partsImage: null,
      isaActivated: false,
      newsIcon,
    };
  },
  methods: {
    init(partsImage) {
      this.isaActivated = true;
      this.partsImage = partsImage;
      return this.shadow;
    },
    back() {
      this.isaActivated = false;
    },
  },
};
</script>
<style scoped>
.introduction-box {
  width: 100%;
  height: 100%;
  justify-content: space-around;
  background-color: white;
  display: flex;
}
.introduction-image {
  width: 2.4rem;
}
.introduction-demo-area {
  width: 6.8rem;
  padding-top: 1rem;
  overflow: hidden;
  height: 100%;

  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.introduction-demo-area ul{
  margin-top: 0.2rem;
}
.introduction-demo-area .imag {
  width: 6rem;
  
}
.introduction-demo-area .imag img {
  width: 100%;
  height: auto;
  padding-top: 0.5rem;
}
.introduction-title {
  font-size: 0.6rem;
  font-weight: bold;
  text-indent: 0.1rem;
  color: #50391e;
}
.introduction-title2 {
  padding-top: 0.2rem;
  font-size: 0.2rem;
  font-weight: bold;
  color: #50391e;
}
.introduction-title3 {
  padding-top: 0.2rem;
  font-size: 0.15rem;
  font-weight: bold;
  text-indent: 0.1rem;
  color: #50391e;
}
.introduction-list {
  padding-top: 0.1rem;
  font-size: 0.2rem;
  font-weight: normal;
  text-indent: 0.1rem;
  color: #50391e;
  /* width: 100%;
  box-sizing: border-box;
  padding-left: 10px;
  position: relative;
  font-size: 18px;
  line-height: 35px;
  margin-top: 20px;
  font-weight: bold;
  color: #000;
  display: list-item; */
}
/* .introduction-image {
  width: 5rem;
} */
.introduction-image img {
  width: 100%;
  height: auto;
  padding-top: 1rem;
}
.introduction-demo-enter-active,
.introduction-demo-leave-active {
  transition: all 0.5s;
}
.introduction-demo-enter, .introduction-demo-leave-to /* .fade-leave-active below version 2.1.8 */ {
  right: -6.5rem;
}
.food-bottom-icons {
  display: block;
  margin: 0 auto;
  width: 5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/home/modules/round-spare-parts/help.vue